/**
 * 格式化视频时长为 ISO 8601 时间持续格式（如 PT1H30M45S）。
 *
 * @param {number} duration - 视频时长（以秒为单位）。
 * @returns {string} 格式化后的 ISO 8601 时间持续格式。
 *
 * @example
 * // 使用示例：
 * const videoDurationInSeconds = 5678;
 * const formattedDuration = formatVideoDuration(videoDurationInSeconds);
 * console.log(formattedDuration);
 * // 输出: 'PT1H34M38S'
 */
export function formatVideoDuration(duration: number): string {
  // 计算小时、分钟和秒
  const hours = Math.floor(duration / 3600)
  const minutes = Math.floor((duration % 3600) / 60)
  const seconds = Math.floor(duration % 60)

  // 返回格式化后的 ISO 8601 时间持续格式
  return `PT${hours.toString().padStart(2, '0')}H${minutes
    .toString()
    .padStart(2, '0')}M${seconds.toString().padStart(2, '0')}S`
}
